package com.findyourbuddies.website.pages

import androidx.compose.runtime.Composable
import com.findyourbuddies.website.components.AppFooter
import com.findyourbuddies.website.components.Carousel
import com.findyourbuddies.website.components.Header
import com.findyourbuddies.website.components.StoreButtons
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.px

@Page
@Composable
fun HomePage() {
    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .gap(60.px),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Section(id = "header") {
                Header()
            }

            Carousel()

            StoreButtons()

            AppFooter()
        }
    }
}

@Composable
fun Section(id: String, content: @Composable () -> Unit) {
    Box(
        modifier = Modifier
            .id(id)
            .fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {
        content()
    }
}
